/* Hookline - Our Work page behaviour. Progressive enhancement: the grid works without this file. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-hlw]');
    if (!root || root.__hlw) return;
    root.__hlw = true;

    var grid = root.querySelector('[data-hlw-grid]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.hlw-card'));
    if (!cards.length) return;

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var state = { type: 'all', client: 'all', open: null };

    // Sort: pinned first, then display order, then newest.
    cards.sort(function (a, b) {
      var d = (+b.dataset.pin) - (+a.dataset.pin);
      if (d) return d;
      d = (+a.dataset.order || 9999) - (+b.dataset.order || 9999);
      if (d) return d;
      return (+b.dataset.date || 0) - (+a.dataset.date || 0);
    });
    cards.forEach(function (c) { grid.appendChild(c); });

    var matchType = function (c, t) {
      if (t === 'all') return true;
      if (t === 'edit-only') return c.dataset.edit === 'true';
      return (' ' + c.dataset.cats + ' ').indexOf(' ' + t + ' ') > -1;
    };
    var matchClient = function (c, cl) { return cl === 'all' || c.dataset.client === cl; };
    var visible = function () { return cards.filter(function (c) { return !c.hidden; }); };

    // Read shareable filter state from the URL.
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('type')) state.type = q.get('type');
      if (q.get('client')) state.client = q.get('client');
    } catch (e) {}

    var chips = $$('.hlw__chip[data-type]');
    var clientOpts = $$('.hlw__client-list [data-client]');
    var clientList = $('[data-hlw-client-list]');
    var clientBtn = $('[data-hlw-client-btn]');

    function render(push) {
      var byClient = cards.filter(function (c) { return matchClient(c, state.client); });
      var activeChipShown = false;
      chips.forEach(function (ch) {
        var t = ch.dataset.type;
        var n = byClient.filter(function (c) { return matchType(c, t); }).length;
        var on = t === state.type;
        ch.hidden = n === 0 && !on && t !== 'all';
        ch.setAttribute('aria-pressed', String(on));
        ch.querySelector('small').textContent = n;
        if (on) activeChipShown = true;
      });
      if (!activeChipShown) { state.type = 'all'; return render(push); }

      var label = 'All clients';
      clientOpts.forEach(function (o) {
        var cl = o.dataset.client;
        var n = cl === 'all' ? cards.length : cards.filter(function (c) { return c.dataset.client === cl; }).length;
        o.hidden = n === 0;
        o.querySelector('small').textContent = n;
        var on = cl === state.client;
        o.setAttribute('aria-selected', String(on));
        if (on && cl !== 'all') label = o.querySelector('span').textContent;
      });
      $('[data-hlw-client-label]').textContent = label;

      var shown = 0;
      cards.forEach(function (c) {
        var ok = matchClient(c, state.client) && matchType(c, state.type);
        c.hidden = !ok;
        if (ok) shown++;
      });

      $$('[data-hlw-strip]').forEach(function (s) {
        var on = s.dataset.hlwStrip === state.client;
        s.hidden = !on;
        if (on) {
          var n = byClient.length;
          s.querySelector('[data-hlw-strip-count]').textContent = n + (n === 1 ? ' project' : ' projects');
        }
      });

      $('[data-hlw-empty]').hidden = shown > 0;
      $('[data-hlw-count]').textContent = shown + (shown === 1 ? ' project' : ' projects') + (state.client !== 'all' ? ' for ' + label : '');

      if (push !== false) {
        try {
          var u = new URL(location.href);
          if (state.type === 'all') u.searchParams.delete('type'); else u.searchParams.set('type', state.type);
          if (state.client === 'all') u.searchParams.delete('client'); else u.searchParams.set('client', state.client);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
    }

    function closeClientList() { clientList.hidden = true; clientBtn.setAttribute('aria-expanded', 'false'); }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var chip = t.closest('.hlw__chip[data-type]');
      if (chip && root.contains(chip)) { state.type = chip.dataset.type; render(); return; }
      if (t.closest('[data-hlw-client-btn]')) {
        clientList.hidden = !clientList.hidden;
        clientBtn.setAttribute('aria-expanded', String(!clientList.hidden));
        return;
      }
      var opt = t.closest('.hlw__client-list [data-client]');
      if (opt) { state.client = opt.dataset.client; state.type = 'all'; closeClientList(); render(); return; }
      if (t.closest('[data-hlw-clear-client]')) { state.client = 'all'; render(); return; }
      if (t.closest('[data-hlw-reset]')) { state.client = 'all'; state.type = 'all'; render(); return; }
      var open = t.closest('[data-hlw-open]');
      if (open) { openViewer(open.closest('.hlw-card')); return; }
    });
    document.addEventListener('click', function (e) {
      if (!clientList.hidden && !e.target.closest('.hlw__client')) closeClientList();
    });

    // Viewer
    var dlg = $('[data-hlw-viewer]');
    var screen = $('[data-hlw-screen]');
    var info = $('[data-hlw-info]');
    var lastFocus = null;

    function embedUrl(url) {
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
      if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?rel=0&playsinline=1';
      m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return 'https://player.vimeo.com/video/' + m[1];
      return '';
    }

    function setPlayer(card) {
      screen.innerHTML = '';
      screen.className = 'hlw-screen ' + (card.dataset.portrait === '1' ? 'hlw-screen--p' : 'hlw-screen--l');
      var src = card.dataset.src, url = card.dataset.url;
      if (src) {
        var v = document.createElement('video');
        v.controls = true; v.playsInline = true; v.preload = 'metadata';
        v.setAttribute('playsinline', '');
        if (card.dataset.poster) v.poster = card.dataset.poster;
        v.src = src;
        screen.appendChild(v);
      } else if (url && embedUrl(url)) {
        var f = document.createElement('iframe');
        f.src = embedUrl(url);
        f.title = 'Video player';
        f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        f.allowFullscreen = true;
        f.loading = 'lazy';
        screen.appendChild(f);
      } else if (card.dataset.poster) {
        var img = document.createElement('img');
        img.src = card.dataset.poster; img.alt = '';
        img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover';
        screen.appendChild(img);
      }
    }

    function openViewer(card) {
      if (!card) return;
      state.open = card;
      setPlayer(card);
      var tpl = card.querySelector('template[data-hlw-detail]');
      info.innerHTML = '';
      if (tpl) info.appendChild(tpl.content.cloneNode(true));
      var rel = cards.filter(function (c) { return c !== card && c.dataset.client && c.dataset.client === card.dataset.client; }).slice(0, 4);
      var relBox = info.querySelector('[data-hlw-related]');
      if (relBox && rel.length) {
        var h = document.createElement('h3'); h.textContent = 'More for this client';
        var g = document.createElement('div'); g.className = 'hlw-viewer__rel';
        rel.forEach(function (c) {
          var b = document.createElement('button'); b.type = 'button';
          b.addEventListener('click', function () { openViewer(c); });
          if (c.dataset.poster) { var im = document.createElement('img'); im.src = c.dataset.poster; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
          var s = document.createElement('span'); s.textContent = c.querySelector('.hlw-card__title').textContent; b.appendChild(s);
          g.appendChild(b);
        });
        relBox.appendChild(h); relBox.appendChild(g);
      }
      if (!dlg.open) {
        lastFocus = document.activeElement;
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
        // Focus the panel, not the first button, so no focus ring shows on open.
        var bx = dlg.querySelector('.hlw-viewer__box');
        if (bx) { bx.setAttribute('tabindex', '-1'); try { bx.focus({ preventScroll: true }); } catch (e) {} }
        document.documentElement.classList.add('hlw-lock');
      }
      var box = dlg.querySelector('.hlw-viewer__box'); if (box) box.scrollTop = 0;
      info.scrollTop = 0;
    }

    function step(dir) {
      var list = visible();
      if (list.indexOf(state.open) < 0) list = cards;
      var i = list.indexOf(state.open);
      openViewer(list[(i + dir + list.length) % list.length]);
    }

    function closeViewer() { if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } } }

    dlg.addEventListener('close', function () {
      screen.innerHTML = '';
      state.open = null;
      document.documentElement.classList.remove('hlw-lock');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-hlw-close]')) { closeViewer(); return; }
      if (e.target.closest('[data-hlw-prev]')) { step(-1); return; }
      if (e.target.closest('[data-hlw-next]')) { step(1); return; }
      var sc = e.target.closest('[data-hlw-show-client]');
      if (sc) {
        state.client = sc.dataset.hlwShowClient; state.type = 'all';
        closeViewer(); render();
        var ex = document.getElementById('hlw-explore');
        if (ex) { try { ex.scrollIntoView({ behavior: 'smooth' }); } catch (x) {} }
      }
    });

    $('[data-hlw-filters]').hidden = false;
    render(false);

    // Scroll reveal. Skipped for reduced motion or old browsers, so everything just shows.
    (function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var els = $$('.hlw__head, .hlw__trust, .hlw__enq-box').concat(cards.slice(1));
      els.forEach(function (el) { el.classList.add('hlw-r'); });
      root.classList.add('hlw--anim');
      var io = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          el.style.setProperty('--d', Math.min(n * 90, 360) + 'ms');
          // Wait two frames so the hidden state is painted first and the fade is visible.
          requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
          io.unobserve(en.target);
          n++;
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
      // Safety net: if the observer never fires, show everything.
      setTimeout(function () { if (!root.querySelector('.hlw-r.is-in')) els.forEach(function (el) { el.classList.add('is-in'); }); }, 3000);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
